<div class="resize-container-6 min-h-screen flex flex-col bg-surface-50 dark:bg-surface-950">
	<div
		class="relative bg-surface-0 dark:bg-surface-950 shadow"
		style="position: sticky; top: 0; z-index: 10000">
		<nav
			class="h-16 relative flex items-center justify-between px-8 lg:px-20 bg-surface-0 dark:bg-surface-900 border-b border-surface-200 dark:border-surface-700">
			<app-logo></app-logo>
			<a
				pStyleClass="@next"
				enterFromClass="hidden"
				leaveToClass="hidden"
				[hideOnOutsideClick]="true"
				resizeSelector=".resize-container-6"
				[hideOnResize]="true"
				class="cursor-pointer block lg:hidden text-surface-700 dark:text-surface-0">
				<i class="pi pi-bars text-xl! leading-normal!"></i>
			</a>
			<!-- mobile nav -->

			<div class="hidden lg:hidden bg-surface-0 dark:bg-surface-900 shadow-md absolute left-0 right-0 top-16 z-200">
				<div class="flex-1 flex flex-col gap-0 px-0 py-4">
					@for (item of navs(); track item.label; let i = $index) {
					<a
						[class]="'flex items-center gap-2 px-6 py-3 cursor-pointer transition-colors duration-150 ' +
								(selectedNav() === item.label ? 'border-l-2 border-rdus-orange-light-500 dark:border-primary-400' : 'border-l-2 border-transparent hover:border-rdus-orange-light-500 dark:hover:border-primary-400')"
						(click)="setSelectedNav(item.label)"
						[routerLink]="[item.to]">
						<span
							[class]="'font-medium ' + (selectedNav() === item.label ? 'text-surface-900 dark:text-surface-0' : 'text-surface-800 dark:text-surface-300')"
							>{{ item.label }}</span
						>
					</a>
					}
				</div>
				<div class="flex items-center justify-between px-6 py-4 border-t border-surface-200 dark:border-surface-700">
					<app-call-us-button bgColor="light"></app-call-us-button>
				</div>
			</div>

			<!-- desktop nav -->
			<div
				class="flex-1 h-full items-end justify-between hidden lg:flex absolute lg:static w-full left-0 top-full shadow-md lg:shadow-none z-10">
				<div class="flex-1 flex items-end justify-center gap-2 bg-surface-0 dark:bg-surface-900 h-full">
					@for (item of navs(); track item.label; let i = $index) {
					<a
						[class]="'flex items-center gap-2 h-full px-4 rounded-t-md cursor-pointer transition-colors duration-150 ' +
                                (selectedNav() === item.label ? 'border-b-2 border-rdus-orange-dark-500 dark:border-primary-400' : 'border-b-2 border-transparent hover:border-rdus-orange-dark-500 dark:hover:border-primary-400')"
						(click)="setSelectedNav(item.label)"
						[routerLink]="[item.to]">
						<span
							[class]="'font-medium ' + (selectedNav() === item.label ? 'text-surface-900 dark:text-surface-0' : 'text-surface-800 dark:text-surface-300')"
							>{{ item.label }}</span
						>
					</a>
					}
				</div>
				<div class="flex items-center self-center gap-8">
					<app-call-us-button bgColor="light"></app-call-us-button>
				</div>
			</div>
		</nav>
		<div class="lg:hidden bg-primary-100">
			<app-call-us-button
				bgColor="light"
				size="small"></app-call-us-button>
		</div>
	</div>

	<div class="flex flex-col flex-auto">
		<div class="flex-auto bg-surface-0">
			<router-outlet></router-outlet>

		</div>
	</div>
	<app-footer></app-footer>
</div>
